import { trackNavigationHeaderClick } from '../../../../../../shared';
import type { VisualItem } from '../../../../../../types';
import { BrandCard } from '../../../../shared';

import './visual-items-grid.scss';

type VisualItemsGridProps = {
    items: VisualItem[];
    onLinkSelect: () => void;
    selectionPath: string[];
};

// Only the `imageOnly` layout (e.g. Brands) renders as an image grid on mobile; other visual
// layouts are flattened into a plain text link list by `nested-level.utils.ts` instead.
export function VisualItemsGrid({ items, onLinkSelect, selectionPath }: Readonly<VisualItemsGridProps>) {
    return (
        <ul aria-label="Navigation links" className="mobile-menu-visual-items-grid">
            {items.map(item => (
                <li key={`${item.href}::${item.title ?? item.label}`} className="mobile-menu-visual-items-grid__item">
                    <BrandCard
                        card={{
                            href: item.href,
                            imageUrl: item.imageUrl,
                            label: item.label,
                            openInNewTab: item.openInNewTab,
                        }}
                        onClick={() => {
                            trackNavigationHeaderClick({
                                selection: [...selectionPath, item.title ?? item.label],
                                linkUrl: item.href,
                                navSection: 'main nav',
                            });
                            onLinkSelect();
                        }}
                    />
                </li>
            ))}
        </ul>
    );
}
